// The white margin as a share of the code, so a print-size PNG keeps the same quiet zone as the 200px one
const QR_PADDING_RATIO = 0.12;

/** The code size that makes the saved PNG, margin included, exactly `imageWidth` pixels wide. */
export function qrSizeForImageWidth(imageWidth: number): number {
  return Math.round(imageWidth / (1 + 2 * QR_PADDING_RATIO));
}

/**
 * Saves the QR code rendered inside `container` as a padded white PNG. `react-qr-code` renders an
 * SVG, which no browser downloads as an image directly, so it is rasterised through a canvas first.
 */
export function downloadQrPng(container: HTMLElement | null, size: number, filename: string): void {
  const svg = container?.querySelector('svg');
  if (!svg) return;
  const svgBlob = new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml;charset=utf-8' });
  const url = URL.createObjectURL(svgBlob);
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement('canvas');
    const padding = Math.round(size * QR_PADDING_RATIO);
    canvas.width = size + padding * 2;
    canvas.height = size + padding * 2;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = '#ffffff'; // theme-exempt: the saved QR PNG is content for print, and scanners need its white quiet zone
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, padding, padding, size, size);
      const a = document.createElement('a');
      a.download = filename.endsWith('.png') ? filename : `${filename}.png`;
      a.href = canvas.toDataURL('image/png');
      a.click();
    }
    URL.revokeObjectURL(url);
  };
  img.onerror = () => URL.revokeObjectURL(url);
  img.src = url;
}
